import { setCompImport } from './comp-import.js';

function load(imp) {
    setCompImport(imp);
}

export { load };
